/**
 *  @class
 *  @function Header
 */
class Header {
  constructor() {
    const header = document.querySelector('.header-section'),
      header_main = document.getElementById('header'),
      menu = document.getElementById('mobile-menu'),
      toggle = document.querySelector('.mobile-toggle-wrapper'),
      setHeaderOffset = this.setHeaderOffset,
      setAnnouncementHeight = this.setAnnouncementHeight,
      setHeaderHeight = this.setHeaderHeight;

    if (!header_main) {
      return;
    }
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          toggle.removeAttribute('open');
          toggle.classList.remove('active');
        }
      }
    });
    toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
      setAnnouncementHeight(header);
      if (toggle.classList.contains('active')) {
        e.preventDefault();
        document.body.classList.remove('overflow-hidden');
        toggle.classList.remove('active');
        this.closeAnimation(toggle);

      } else {
        document.body.classList.add('overflow-hidden');
        setTimeout(() => {
          toggle.classList.add('active');
        });
      }
      window.dispatchEvent(new Event('resize.resize-select'));
    });

    // Mobile Menu offset
    window.addEventListener('scroll', function () {
      setHeaderOffset(header);
      setHeaderHeight(header_main);
      // Sticky Header Class
      if (header_main.classList.contains('header-sticky--active')) {
        let offset = parseInt(header_main.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;

        header_main.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }

    }, {
      passive: true
    });
    window.dispatchEvent(new Event('scroll'));

    if (document.getElementById('shopify-section-announcement-bar')) {
      const a_bar = document.getElementById('shopify-section-announcement-bar');
      window.addEventListener('resize', function () {
        setAnnouncementHeight(a_bar);
      }, {
        passive: true
      });
      window.dispatchEvent(new Event('resize'));
    }
    // Buttons.
    menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    menu.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }
  setAnnouncementHeight(a_bar) {
    let h = a_bar.clientHeight;
    document.documentElement.style.setProperty('--announcement-height', h + 'px');
  }
  setHeaderOffset(header) {
    let h = header.getBoundingClientRect().top;
    document.documentElement.style.setProperty('--header-offset', h + 'px');
  }
  setHeaderHeight(header) {
    let h = header.clientHeight;
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.link-container');
    const isOpen = detailsElement.hasAttribute('open');

    setTimeout(() => {
      detailsElement.classList.add('menu-opening');
      parentMenuElement && parentMenuElement.classList.add('submenu-open');
    }, 100);
  }
  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        detailsElement.querySelectorAll('details').forEach((details) => {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
          details.classList.remove('submenu-open');
        });
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu > .menu-item-has-children:not(.menu-item-has-megamenu) > .sub-menu');

      if (!this.submenus.length) return;

      // Resize event with debounce
      window.addEventListener('resize', this.debounce(() => this.resizeSubMenus(), 100));

      // Trigger initial resize
      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(() => {
        this.resizeSubMenus();
      });
    }

    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        const sub_submenus = submenu.querySelectorAll(':scope > .menu-item-has-children > .sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          const w = sub_submenu.offsetWidth;
          const l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10;
          const total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }

    // Debounce function to limit the rate of event handling
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  }
  customElements.define('full-menu', FullMenu);
}

/**
 *  @class
 *  @function MegaMenuHover 
 */
class MegaMenuHover {
  constructor() {
    this.container = document.getElementById('header');
    this.buttons = document.querySelectorAll('.mega-menu-level-1 .has-sub-menu');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.buttons.forEach((item) => {
      const firstItemActive = document.querySelector('.mega-menu-level-1 .item-has-children .has-sub-menu.active');
      if (firstItemActive) {
        firstItemActive.click();
      }

      item.addEventListener('click', (event) => {
        this.toggleMenu(event, item);
      });
    });
  }

  toggleMenu(event, item) {
    const dataTitle = item.getAttribute('data-item');
    const menuSub = this.container.querySelector(`[data-menu-sub-item="${dataTitle}"]`);
    const menuSubSub = this.container.querySelector(`[data-menu-sub-sub-item="${dataTitle}"]`);
    const itemMenuId = this.container.querySelector(`[data-item="${dataTitle}"]`);

    this.buttons.forEach((btn) => btn.classList.remove('active'));
    this.container.querySelectorAll('.mega-menu-level-2 .data-menu-sub-item').forEach((sub) => sub.classList.remove('active'));
    this.container.querySelectorAll('.mega-menu-level-3 .data-menu-sub-sub-item').forEach((sub) => sub.classList.remove('active'));

    if (itemMenuId) {
      itemMenuId.classList.add('active');
    }

    this.container.classList.add('show_submenu');

    if (menuSub) {
      menuSub.classList.add('active');
    }
    if (menuSubSub) {
      menuSubSub.classList.add('active');
    }
  }

  close() {
    this.container.classList.remove('active');
  }
}
